import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CurrentUser = {
  sub: string;
  preferredUsername: string;
  name: string;
  email: string;
};

type CurrentUserState = {
  user: CurrentUser | null;
};

const initialState: CurrentUserState = {
  user: null,
};

const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setCurrentUser(state, action: PayloadAction<CurrentUser>) {
      state.user = action.payload;
    },
  },
});

export const { setCurrentUser } = currentUserSlice.actions;
export default currentUserSlice.reducer;
